import { ManagersList } from '../components/ManagersList';

import { useDepartmentStore } from '@/stores/department';

export const Managers = () => {
  const department = useDepartmentStore((state) => state.selected);
  return <ManagersList department={department} />;
};
